import React from "react";
import { Trans, useTranslation } from "react-i18next";
import tw, { css } from "twin.macro";

import EquipmentOwnerSvg from "../../../static/images/equipment-owners.svg";
import ExpertSvg from "../../../static/images/experts.svg";
import MaterialOwnerSvg from "../../../static/images/material-owners.svg";
import { BookMeeting } from "../../components/BookMeeting";
import { Container } from "../../components/Container";
import ProfileTypeDescription from "../../components/ProfileTypeDescription";
import { getTranslationList } from "../../utils/common";

const profiles = css`
  h1 {
    ${tw`text-4xl sm:text-5xl md:text-7xl leading-none font-black mt-8`}
  }
`;

const ProfilesBlock: React.FC = ({ ...rest }) => {
  const { t } = useTranslation();

  const materialOwnerList = getTranslationList(t, "index.materialOwner.list");
  const equipmentOwnerList = getTranslationList(t, "index.equipmentOwner.list");
  const expertList = getTranslationList(t, "index.experts.list");

  return (
    <Container {...rest}>
      <section css={profiles}>
        <h3 tw="text-xl sm:text-2xl md:text-4xl mt-2 mb-12 items-center justify-center mx-auto text-center max-w-3xl">
          <Trans i18nKey="about.triangularPartner" components={{ bold: <strong /> }} />
          <br />
          {t("about.findSolutions")}
        </h3>
        <ProfileTypeDescription header={t("index.materialOwner.header")} list={materialOwnerList}>
          <MaterialOwnerSvg />
        </ProfileTypeDescription>

        <ProfileTypeDescription header={t("index.equipmentOwner.header")} list={equipmentOwnerList} revert={true}>
          <EquipmentOwnerSvg />
        </ProfileTypeDescription>

        <ProfileTypeDescription header={t("index.experts.header")} list={expertList}>
          <ExpertSvg />
        </ProfileTypeDescription>

        <BookMeeting commentFirst={true} />
      </section>
    </Container>
  );
};

export default ProfilesBlock;
